<template>
  <widgetModal
    :title="!email_form.id ? 'Create signature' : 'Update  signature'"
    subtitle="You can add information directly from this form"
    btnlefttext="Save Changes"
    btncentertext="Cancel"
    btnrighttext=""
    :leftloading="email_loading"
    :rightloading="false"
    :centerloading="false"
    :footerhidden="false"
    footer_padding="20px 20px"
    header_padding="20px 20px"
    body_padding="0px 20px"
    width="580px"
    @onLeftClick="submitSignature()"
    @onCenterClick="onCancel"
  >
    <div class="widget-modal-body-noscoll">
      <widgetInputWrapper title="Name*">
        <widgetInput
          v-model="email_form.name"
          type="text"
          placeholder="Add Signature name"
        ></widgetInput>
      </widgetInputWrapper>
      <widgetInputWrapper title="Email Signature">
        <html-editor
          placeholder="Type here..."
          v-model="email_form.message"
          id="edit-descr"
        />
      </widgetInputWrapper>
    </div>
  </widgetModal>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => {
    return {
      email_loading: false,
      email_form: {
        id: null,
        name: "",
        message: "",
      },
    };
  },
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.updateEmail(vm.value);
    } else {
      vm.newEmail();
    }
  },
  computed: {},
  watch: {},
  methods: {
    updateEmail(item) {
      let vm = this;
      vm.email_form = {
        id: item.id,
        name: item.name,
        message: item.message,
      };
    },
    newEmail() {
      let vm = this;
      vm.email_form = {
        id: null,
        name: "",
        message: "",
      };
    },
    submitSignature() {
      let vm = this;
      const rules = {
        name: {
          run: (value) => {
            if (!value) {
              return "Please add signature name";
            }
            return false;
          },
        },
        message: {
          run: (value) => {
            if (!value) {
              return "Please add signature content ";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.email_form, rules)) {
        if (!vm.email_form.id) {
          vm.email_loading = true;
          vm.$store
            .dispatch("PROCESSMESSAGE_EMAIL_SIGNATURE_ADD_NEW", vm.email_form)
            .then((responce) => {
              vm.email_loading = false;
              vm.$emit("saved");
              vm.$notify({
                group: "status",
                title: "Success",
                text: "Signature is now added",
                type: "success",
                duration: 3000,
              });
            })
            .catch((error) => {
              vm.email_loading = false;
              vm.$notify({
                group: "status",
                title: "Warning",
                text: "Something wrong while adding signature",
                type: "warn",
                duration: 3000,
              });
            });
        } else {
          vm.email_loading = true;
          vm.$store
            .dispatch("PROCESSMESSAGE_EMAIL_SIGNATURE_UPDATE", vm.email_form)
            .then((responce) => {
              vm.email_loading = false;
              vm.$emit("saved");
              vm.$notify({
                group: "status",
                title: "Success",
                text: "Email is now updated",
                type: "success",
                duration: 3000,
              });
            })
            .catch((error) => {
              vm.email_loading = false;
              vm.$notify({
                group: "status",
                title: "Warning",
                text: "Something wrong while updating email",
                type: "warn",
                duration: 3000,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
</style>


